module.exports = __webpack_public_path__ + "img/SpectroPicCartoon.52a28e05.png";